import React from 'react';

import './ImageLoader.css';

const _loaded = {};

class ImageLoader extends React.PureComponent {
  _isMounted = true;

  state = {
    loaded: _loaded[this.props.src],
    style: { marginTop: '10%', marginLeft: '10%' },
    isLoaded: true
  };

  static defaultProps = {
    className: '',
    loadingClassName: 'loader',
    loadedClassName: 'img-loaded',
    onload: function() {}
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  onImgLoaded = (e) => {
    const width = e.target.naturalWidth;
    const height = e.target.naturalHeight;
    e.target.style.opecity = 1;
    const classList = e.target.classList;
    classList.remove('loadingClassName');
    //classList.add('loadedClassName');
    if (this._isMounted) {
      this.props.onload(width, height);
      //this.setState({ loaded: true });
    }
  };

  timeOut = null;
  reloadImage = () => {
    this.timeOut = setTimeout(() => {
      this.setState({ isLoaded: true });
    }, this.numberOfRetry * 500);
  };

  numberOfRetry: Number = 0;
  onError = (event: Event) => {
    if (event && !this.once) {
      this.numberOfRetry++;
      if (this.numberOfRetry === 3) {
        this.removeTimeout();
      } else {
        this.setState({ isLoaded: false });
        this.reloadImage();
      }
    }
  };

  removeTimeout() {
    clearTimeout(this.timeOut);
  }

  render() {
    const { isLoaded } = this.state;
    return (
      <React.Fragment>
        {/* {!this.state.loaded ? <div name="ImageLoader" className={'loader-small'}></div> : null} */}
        {isLoaded ? (
          <img
            crossOrigin="use-credentials"
            name="ImageLoader"
            onLoad={(event) => {
              this.onImgLoaded(event);
            }}
            onError={this.onError}
            src={this.props.src}
            className={`loadingClassName ${this.props.previewClassName}`}
            style={this.props.style}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default ImageLoader;
